"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WidgetRequestTypeLabels = void 0;
exports.WidgetRequestTypeLabels = {
    RequestAppointment: 'Request an Appointment',
    RequestBoarding: 'Request Boarding',
    RequestGroomingAppoinment: 'Request Grooming',
    RequestRxRefill: 'Request Med & Food Refill',
    AdvancedRequestRxRefill: 'Find My Prescription',
    RequestMedicalRecords: 'Request Medical Records',
    RequestVirtualConsult: 'Request a Virtual Consultation',
    TalkToStaff: 'Talk to staff',
    InboundSms: 'Incoming Text Message',
    DirectBooking: 'Book an Appointment',
    Teletriage: 'Care Plan Live Chat',
    LiveAgent: 'Live Agent',
};
//# sourceMappingURL=WidgetRequestTypeLabels.js.map